<template>
  <div>
    <v-card outlined tile height="100%">
        <v-expansion-panels class="overflow-y-auto" max-height="640">
            <v-expansion-panel hide-actions v-show="habData.length > 0">
                <v-expansion-panel-header class="panel-header">
                    <template v-slot:actions>
                      <v-progress-circular
                          :value="service.hab.progress"
                          :color="service.hab.incomplete ? 'red' : 'success'"
                      >
                        <v-icon
                            :color="service.hab.incomplete ? 'red' : 'success'"
                            small
                        >
                          {{
                            service.hab.progress === 100
                                ? "mdi-check"
                                : "mdi-medical-bag"
                          }}
                        </v-icon>
                      </v-progress-circular
                      >
                    </template>
                    <v-row align="center" justify="center" no-gutters>
                    <v-col cols="12" sm="12" md="4" class="my-1">
                      <v-row>
                        <v-col cols="4" sm="4" md="2" class="hidden-sm-and-down">
                          <v-avatar size="36px">
                            <v-icon color="teal">mdi-medical-bag</v-icon>
                          </v-avatar>
                        </v-col>
                        <v-col cols="12" xs="12" sm="12" md="10" class="my-1">
                          <div class="pa-2 d-flex justify-center ">
                            <strong> HAB </strong>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="12" md="8">
                      <v-row wrap>
                        <v-col cols="12" sm="12" md="12">
                          <div class="d-flex justify-center pa-1">
                            <v-row class="justify-center justify-md-start ">
                              <v-chip
                                  :color="
                                  service.hab.incomplete
                                    ? 'red lighten-4'
                                    : 'success lighten-4'
                                "
                                  class="ml-0 mx-1 black--text my-1"
                                  label
                                  small
                              >
                                {{
                                  service.hab.incomplete
                                      ? "INCOMPLETE"
                                      : "COMPLETE"
                                }}
                              </v-chip>

                              <v-chip
                                  color="teal lighten-4"
                                  class="ml-0 black--text my-1"
                                  label
                                  small
                              >
                                <span class="text-overline"
                                >{{ service.hab.completed }} /
                                  {{ service.hab.total }} HAB completed</span
                                >
                              </v-chip>
                            </v-row>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expansion-panel-header>
                <CardItem
                    :habData="habData"
                    @getHAB="fetchHAB"
                    :userDateToday="userDateToday"
                />
            </v-expansion-panel>
        </v-expansion-panels>
    </v-card>
  </div>
</template>

<script>
/*eslint-disable */
import CardItem from "./CardItem";
//import { mapMutations } from "vuex";

export default {
  components: {
    CardItem,
    //ConfirmationDialog,
  },
  props: {
    habData: {
      type: Array,
    },
    userDateToday:{
    }
  },

  data() {
    return {
      clientID: this.$route.params.clientID,
    };
  },

  computed: {
    service() {
      const value = 100;

      const adminTime = (hab) => {
        const incomplete = hab.filter((item) => item.isSigned).length != hab.length;

        const completed = hab.filter((item) => item.isSigned).length;

        const total = hab.length;

        return {
          incomplete: incomplete,
          completed: completed,
          total: total,
          progress: (value / total) * completed,
        };
      };

      return {
        hab: adminTime(this.habData),
      };
    },
  },

  methods: {
    fetchHAB(){
      this.$emit("getHAB");
    }
  },
};
</script>

<style scoped>
.v-expansion-panel--active
> .v-expansion-panel-header--active
.v-expansion-panel-header__icon:not(.v-expansion-panel-header__icon--disable-rotate)
.v-icon {
  transform: none !important;
}

</style>
